import React from "react";

const SaleRateKharifSeedsVegetables = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Kharif Seeds - Vegetables</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <h6>Our seed remains available easily at:</h6>

            <ol>
              <li>HSDC sale counters.</li>
              <li>
                Farmers&#39; Service Centres of Haryana Agro Industries
                Corporation.
              </li>
              <li>Mini Banks.</li>
              <li>Co-op. Societies of HAFED.</li>
              <li>Farmers&#39; Service Centres of HLRDC.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th colspan="6">Sale Rate for Summer / Kharif 2025</th>
                  </tr>
                  <tr>
                    <th rowspan="2">Sr.No.</th>
                    <th rowspan="2">Vegetable</th>
                    <th rowspan="2">Variety</th>
                    <th colspan="3"> Rate Rs. per Kg.</th>
                  </tr>
                  <tr>
                    <th>Full Sale Rate</th>
                    <th>Subsidy</th>
                    <th>Subsidized Sale Rate to farmer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Kitchen Garden Packet</td>
                    <td>
                      Kitchen Garden Packet containing 11 Nos. various crops
                      (Packing size – 100 gm)
                    </td>
                    <td>110/- (per packet)</td>
                    <td>-</td>
                    <td>110/- (per packet)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRateKharifSeedsVegetables;
